<script>
import utilsMixin from '@shared/mixins/utils';
import PaymentMethodsCard from '@school/components/PaymentMethodsCard.vue';

export default {
  mixins: [utilsMixin],
  components: { PaymentMethodsCard },
  computed: {
    hasPaymentMethod() {
      const customer = this.$store.getters['auth/customer'];
      return (
        customer.card_exp_month != null
        && customer.card_exp_year != null
        && customer.card_last4 != null
      );
    },
  },
  methods: {
    onPaymentSuccess() {
      this.$showMessage.success();
    },
  },
  i18n: {
    messages: {
      en: {
        payment_methods: 'Payment Methods',
        no_payment_method: 'No payment method saved',
        add_payment_method: 'Add a payment method',
        payment_method_help: 'Payment methods are automatically saved when you make a purchase or subscribe to a plan.',
      },
      fr: {
        payment_methods: 'Moyens de paiement',
        no_payment_method: 'Aucun moyen de paiement enregistré',
        add_payment_method: 'Ajouter un moyen de paiement',
        payment_method_help: 'Les moyens de paiement sont automatiquement enregistrés lors d\'un achat ou d\'un abonnement.',
      },
    },
  },
};
</script>

<template>
  <div>
    <PaymentMethodsCard v-if="hasPaymentMethod" @success="onPaymentSuccess" />

    <div v-else class="box has-text-centered">
      <div class="content">
        <p class="has-text-grey mb-4">
          {{ $t('no_payment_method') }}
        </p>
        <p class="has-text-grey-light is-size-7">
          {{ $t('payment_method_help') }}
        </p>
      </div>
    </div>
  </div>
</template>
